module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticStyle: {
      "background": "#eee"
    }
  }, [_c('div', {
    staticClass: "topnav"
  }, [_c('div', {
    staticClass: "marginauto flex justify-between align-center",
    staticStyle: {
      "width": "82%",
      "height": "80px"
    }
  }, [_c('div', {
    staticClass: "text-white",
    staticStyle: {
      "font-size": "25px",
      "font-weight": "600"
    }
  }, [_vm._v("中云微迅创新平台")]), _vm._v(" "), _c('div', {
    staticClass: "text-white pointer",
    staticStyle: {
      "font-size": "18px"
    },
    on: {
      "click": _vm.tohome
    }
  }, [_vm._v("首页")])])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('el-image', {
    staticStyle: {
      "width": "100%",
      "display": "block",
      "height": "410px"
    },
    attrs: {
      "src": "/static/assets/images/p4.jpg",
      "fit": "fill"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "box1",
    staticStyle: {
      "bacground": "rgba(255, 255, 255, 0)"
    }
  }, [_c('div', {
    staticClass: "box1_left pointer"
  }, _vm._l((_vm.leftlist), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "box1_left_center",
      style: (_vm.cIndex == index ? 'color: #3973ff;' : ''),
      on: {
        "click": function($event) {
          return _vm.changeleft(item.path, index)
        }
      }
    }, [_vm._v("\n          " + _vm._s(item.name) + "\n        ")])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "box1_right"
  }, [_c('router-view')], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b063a61e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/system/system.vue
// module id = 420
// module chunks = 1